import React, { Component } from "react";
import {
    Card,
    CardBody,
    Progress, TabContent, TabPane, Nav, NavItem, NavLink, Modal, ModalHeader, ModalBody
} from "reactstrap";
import classnames from 'classnames';
import { authHeader } from '../../_helpers';
import NotificationSystem from "react-notification-system";
import { connect } from "react-redux";
import { alertConstants, appConstants } from "../../_constants";
import { apiActions } from "../../_actions/api.actions";

import ManifestUploadPanel from './upload-panel';

import { appHelpers, store } from "../../_helpers";

import './style.css';
import { commonActions, alertActions } from "../../_actions";
import Summary from "./summary";
import ManifestSummary from "./manifest_summary";
import { apiService, commonService } from "../../_services";
import PageEmptyContent from "../utils/page.empty-content";
import UploadManifestRecords from "./manifest-table";
import ViewDetails from "./view-details";
import ErrorDetails from "./ErrorDetails";

const months = [
    { label: "January", value: 1 },
    { label: "February", value: 2 },
    { label: "March", value: 3 },
    { label: "April", value: 4 },
    { label: "May", value: 5 },
    { label: "June", value: 6 },
    { label: "July", value: 7 },
    { label: "August", value: 8 },
    { label: "September", value: 9 },
    { label: "October", value: 10 },
    { label: "November", value: 11 },
    { label: "December", value: 12 }
];

const ViewContent = ({ children }) => (
    <div className="view-content view-components">{children}</div>
);

class ManifestUploadViewContent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            airlines: [],
            monthOptions: months,
            selectedMonth: '',
            file: null,
            fileName: null,
            airlineId: '',


            //page error
            contentError: false, //Errors that affect content on the page
            componentErrorMessages: [], //Errors generated within the component form
            componentError: false, //Errors generated within the component
            error: false, //Error state mutable via Redux
            success: false, //Success message mutable via Redux

            // alert messages
            alertMessage: {
                type: null,
                message: null
            },
            //    Notification
            notification: {
                // title: 'Default Title',
                message: 'Default Message',
                level: 'success',
                position: 'tr',
                dismissible: true
            },
            activeTab: '1',
            manifestSummary: null,
            summary: null,
            records: null,
            pageSize: 10,
            totalCount: 0,
            currentPage: 1,
            from: 0,
            openModal: false,
            eachRecord: ""
        };

        this._notificationSystem = null;
        this._lastNotificationAdded = null;

    }

    componentDidMount() {
        this._notificationSystem = this.refs.notificationSystem;
        const reduxState = store.getState();
        let { airlinesCarriers } = reduxState;
        if (airlinesCarriers) {
            this.setState({ airlines: airlinesCarriers.Results })
        } else {
            this.fetchAirlines();
        }
    }
    componentWillReceiveProps = function (nextProps) {
        const { alert } = nextProps;
        const { modal } = nextProps;

        if (alert) {
            if (alert.type === alertConstants.SUCCESS) {
                // this.setState({error: false, success: alert.message})
                this.setState({ error: false, success: 'Operation successful' });
                this.resetForm();
            }
            else if (alert.type === alertConstants.CLEAR) {
                this.setState({ success: false, error: false })

            } else {
                this.setState({ success: false, error: alert.message })
            }
        }
        if (modal) {
            if (modal.type === appConstants.OPEN_MODAL) {
                this.setState({
                    modal: true,
                    modalClass: modal.modalClass
                })
            } else if (modal.type === appConstants.CLOSE_MODAL) {
                this.setState({
                    modal: false,
                    modalClass: modal.modalClass
                });
                this.resetForm();
            }
        }
    };

    toggle(tab) {
        if (this.state.activeTab !== tab) {
            this.setState({
                activeTab: tab
            });
        }
    }
    handleFormSubmit = (event) => {
        if (this.validateInput()) {
            event.preventDefault();
            const { dispatch } = this.props;
            this.setState({ contentError: false });
            dispatch(apiActions.startRequest());
            const { selectedMonth, airlineId, file } = this.state;
            let data = new FormData();
            data.append('', file);
            data.append('Month', selectedMonth);
            data.append('Airline', airlineId);

            commonService.uploadManifest(data).then(
                (response) => {
                    if (response.status === appConstants.SUCCESS_RESPONSE) {
                        this.setState({ manifestSummary: response.response.ManifestSummary, summary: response.response });
                        this.notify("Manifest was uploaded successfully", appConstants.NOTIFY_SUCCESS);
                        dispatch(apiActions.endRequest());
                        this.resetForm();
                        window.location.reload()
                        // this.props.history.push('/upload/manifest');
                        this.featchManifestUploads();
                    }
                    else if (response.status === appConstants.ERROR_RESPONSE) {
                        this.notify(response.response, appConstants.NOTIFY_ERROR);
                        dispatch(apiActions.endRequest());
                    }
                }
            ).catch(
                (error) => {
                    let errorMessage = apiService.interpretErrorResponse(error);
                    this.notify(errorMessage, appConstants.NOTIFY_ERROR);
                    dispatch(apiActions.endRequest());
                }
            )
        }
    };
    resetForm = () => {
        this.setState({ selectedMonth: "", file: null, airlineId: '' });
    };

    toggleModal = (e, eachRecord) => {
        this.setState({
            openModal: !this.state.openModal,
            eachRecord
        });
    };

    // toggleModal = () => {
    //     this.setState({ openModal: !this.state.openModal});
    // };

    toggleErrorModal = (e, eachRecord) => {
        this.setState({
            openModal: !this.state.openModal,
            eachRecord
        });
    };

    handleSelectChange = (payload, attribute) => {
        let currState = this.state;
        let errorMessages = this.state.componentErrorMessages;
        errorMessages[attribute] = false;
        currState[attribute] = (payload) ? payload.Id : '';
        this.setState(currState);
        this.setState({ outstandingErrorMessages: errorMessages });

    };

    handleFileChange = (event) => {
        this.setState({ file: event.target.files[0] });
    };

    fetchAirlines = () => {
        this.setState({ contentError: false });
        const { dispatch, airlinesCarriers } = this.props;
        if (!airlinesCarriers) {
            dispatch(apiActions.startFullPageRequest());
        } else {
            dispatch(apiActions.startRequest());
        }

        dispatch(commonActions.getAirlinesCarriers())
            .then(() => {
                let { airlinesCarriers } = this.props;
                this.setState({ airlines: airlinesCarriers.Results });
                dispatch(apiActions.endRequest());
            }).catch(error => {
                let errorMessage = appHelpers.interpretErrorResponse(error);
                this.notify(errorMessage, appConstants.NOTIFY_ERROR);
                this.setState({ contentError: errorMessage });
                dispatch(apiActions.endRequest());
            });
    };
    notify = (message, level) => {
        let notification = this.state.notification;
        notification['message'] = message;
        notification['level'] = level;
        notification.onRemove = this.onRemove;
        this._lastNotificationAdded = this._notificationSystem.addNotification(notification);
    };

    onRemove = (notification) => {
        if (this._lastNotificationAdded && notification.uid === this._lastNotificationAdded.uid) {
            this._lastNotificationAdded = null;
        }
    };
    validateInput = () => {
        let _errs_ = [];
        let formValid = true;
        if (this.state.airlineId === '') {
            _errs_['airlineId'] = 'Please select airline';
            formValid = false;
        }
        if (this.state.selectedMonth === '') {
            _errs_['selectedMonth'] = 'Please select month';
            formValid = false;
        }
        if (this.state.file === null) {
            _errs_['file'] = 'Please select file';
            formValid = false;
        }
        this.setState({ componentErrorMessages: _errs_ });
        return formValid;
    };

    featchManifestUploads = async (pageNumber) => {
        const { dispatch } = this.props;
        const { selectedMonth, pageSize, airlineId } = this.state;
        this.setState({ contentError: false });
        if (pageNumber === null) {
            dispatch(apiActions.startFullPageRequest());
            pageNumber = 1;
        } else {
            dispatch(apiActions.startRequest());
        }
        const payload = {
            PageSize: pageSize,
            From: pageNumber === 1 || pageNumber === 0 ? 0 : pageNumber - 1,
            // From:pageNumber,
            Parameter: {
                "Month": selectedMonth,
                "AirlineId": airlineId
            }

        };
        // console.log(pageNumber, "pageNumber");

        dispatch(apiActions.startRequest());
        commonService.fetchUploadManifest(payload)
            .then(res => {
                let response = res.response;
                if (res.status === appConstants.SUCCESS_RESPONSE) {
                    this.setState({
                        records: response.data.Results,
                        totalCount: response.data.Count,
                        currentPage: pageNumber,
                        summary:response.data.Results,
                        manifestSummary: response.data.Results,
                    });
                    dispatch(apiActions.endRequest());
                } else if (res.status === appConstants.ERROR_RESPONSE) {
                    dispatch(
                        alertActions.error(
                            appHelpers.interpretErrorResponseAlt2(res.response)
                        )
                    );
                    dispatch(apiActions.endRequest());
                }
            })
            .catch(err => {
                dispatch(
                    alertActions.error(appHelpers.interpretErrorResponseAlt2(err))
                );
                dispatch(apiActions.endRequest());
            });
    };

//     const filteredFields = editablefieldsData
//     .filter((item) => item.isActive === true)
//     .map((item) => item.invoiceField);

//   return filteredFields ? filteredFields : [];
    render() {
        const { manifestSummary, summary, componentErrorMessages, file, airlineId, selectedMonth, airlines, records, currentPage, totalCount, pageSize, openModal, eachRecord } = this.state;
        const { requesting, pageRequesting } = this.props;
        return (
            <div className="view">
                <ViewContent>
                    <Card className="mb-4" style={{ overflow: "visible" }}>
                        {/*Progress bar for Pending API Request*/}
                        {((pageRequesting || requesting) && !pageRequesting) && <Progress striped animated color="success" value={100} className="mb-2" />}

                        {
                            <CardBody>
                                <div>
                                    <ManifestUploadPanel
                                        airlines={airlines}
                                        componentErrorMessages={componentErrorMessages}
                                        file={file}
                                        airlineId={airlineId}
                                        selectedMonth={selectedMonth}
                                        handleFileChange={this.handleFileChange}
                                        handleSelectChange={this.handleSelectChange}
                                        handleUpload={this.handleFormSubmit}
                                        handleSearch={this.featchManifestUploads}
                                    />
                                    {/* 
                                    <Nav tabs className='ml-3'>
                        <NavItem>
                            <NavLink
                                className={classnames({ active: this.state.activeTab === '1' })}
                                onClick={() => { this.toggle('1'); }}
                            >
                                Summary
                            </NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink
                                className={classnames({ active: this.state.activeTab === '2' })}
                                onClick={() => { this.toggle('2'); }}
                            >
                                Manifest Summary
                            </NavLink>
                        </NavItem>
                    </Nav>

                                    <TabContent activeTab={this.state.activeTab} className='ml-3 pt-2'>
                                        <TabPane tabId="1">
                                            {(summary) &&
                                                <Summary summary={summary} />
                                            }
                                            {(!summary) &&
                                                <PageEmptyContent message={'Upload manifest file'} />
                                            }

                                        </TabPane>
                                        <TabPane tabId="2">
                                            {(manifestSummary) &&
                                                <ManifestSummary manifestSummary={manifestSummary} />
                                            }
                                            {(!manifestSummary) &&
                                                <PageEmptyContent message={'Upload manifest file'} />
                                            }
                                        </TabPane>
                                    </TabContent> */}

                                    {!pageRequesting && records && (
                                        <div>
                                            <UploadManifestRecords
                                                records={records}
                                                currentPage={currentPage}
                                                pageDataCallback={this.featchManifestUploads}
                                                pageSize={pageSize}
                                                totalCount={totalCount}
                                                toggleModal={this.toggleModal.bind(this)}
                                                toggleErrorModal={this.toggleErrorModal.bind(this)}

                                            />
                                        </div>
                                    )}
                                    {!pageRequesting && !records && (
                                        <PageEmptyContent message="No record match your search!" />
                                    )}

                                </div>
                                <Modal size={'lg'} isOpen={openModal} 
                                
                                toggle={(e) => this.toggleModal(e, this.state.eachRecord)}
                                // toggle={this.toggleModal}
                                 className={this.state.modalClass}>
                                    <ModalHeader 
                                    toggle={(e) => this.toggleModal(e, this.state.eachRecord)}
                                    // toggle={this.toggleModal}
                                    >Manifest Details</ModalHeader>
                                    <ModalBody>

                                        {/* <ViewDetails
                                     records={eachRecord}
                                     /> */}
                                        <Nav tabs className='ml-3'>
                                            <NavItem>
                                                <NavLink
                                                    className={classnames({ active: this.state.activeTab === '1' })}
                                                    onClick={() => { this.toggle('1'); }}
                                                >
                                                    Summary
                                                </NavLink>
                                            </NavItem>
                                            <NavItem>
                                                <NavLink
                                                    className={classnames({ active: this.state.activeTab === '2' })}
                                                    onClick={() => { this.toggle('2'); }}
                                                >
                                                    Manifest Summary
                                                </NavLink>
                                            </NavItem>
                                        </Nav>

                                        <TabContent activeTab={this.state.activeTab} className='ml-3 pt-2'>
                                            <TabPane tabId="1">
                                                {(summary) &&
                                                    <Summary 
                                                    records={eachRecord} 
                                                    />
                                                }
                                               

                                            </TabPane>
                                            <TabPane tabId="2">
                                                {(manifestSummary) &&
                                                    <ManifestSummary records={eachRecord} />
                                                }
                                               
                                            </TabPane>
                                        </TabContent>

                                    </ModalBody>

                                </Modal>


                            </CardBody>
                        }
                        <NotificationSystem ref="notificationSystem" />
                    </Card>
                </ViewContent>
            </div>
        );
    }
}

function mapStateToProps(state, ownProps) {
    const { loggingIn } = state.authentication;
    const { pageRequesting, requesting } = state.api;
    const { modal, alert, airlinesCarriers } = state;
    return {
        loggingIn,
        requesting,
        pageRequesting,
        modal,
        alert,
        airlinesCarriers,
    };
}
export default connect(mapStateToProps)(ManifestUploadViewContent);



// WEBPACK FOOTER //
// ./src/views/uploadManifest/view-content.js